<!--CONTENIDO ITEM DATOS DEMANDADO-->
<ng-container>
  <div class="wrapper__form">
    <app-form
      [title]="' '"
      [fields]="formFieldsTipoPersona"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioTipoPersona($event)"
      [idEntidad]="entidadId" />
    <br />

    <app-form
      [fields]="formFieldsDemandadoNatural"
      *ngIf="formTipoPersona.value?.tipoPersona == TIPO_PERSONA_NATURAL && mostrarFormulario"
      [title]="comunText['persona-natural-select']"
      [withSubmitButton]="false"
      (changedControl)="
        onChangeValidarFormulario($event); validarFormularioDemandado($event)
      "
      (changeAction)="personaDemandada($event)"
      [idEntidad]="entidadId" />

    <app-form
      [fields]="formFieldsDemandadoJuridic"
      *ngIf="formTipoPersona.value?.tipoPersona == TIPO_PERSONA_JURIDICA && mostrarFormulario"
      [title]="comunText['persona-juridica-select']"
      [withSubmitButton]="false"
      (changedControl)="
        onChangeValidarFormulario($event); validarFormularioDemandado($event)
      "
      (changeAction)="personaDemandada($event)"
      [idEntidad]="entidadId" />

    <div *ngIf="mensajeErrorDemandado.length > 0" class="invalid-feedback mt-5">
      {{ mensajeErrorDemandado }}
    </div>

    <div class="d-flex flex-wrap justify-content-end gap-2 mt-md-5 mt-3">
      <button
        *ngIf="indexEditarDemandado !== undefined"
        type="submit"
        class="btn-govco fill-btn-danger-govco mt-3 ms-2"
        (click)="cancelarEditarDemandado()"
        aria-label="Cancelar edición">
        {{ proconText['cancelar'] }}
      </button>
      <button
        type="submit"
        class="btn-govco fill-add-govco mt-3"
        [disabled]="isButtonDisabled()"
        *ngIf="
          formTipoPersona.value?.tipoPersona === '1' ||
          formTipoPersona.value?.tipoPersona === '2'
        "
        (click)="agregarDemandado(indexEditarDemandado)"
        aria-label="Guardar demandado">
        {{ proconText['tramite-sic-comp-desleal']['guardar-demandado'] }}
      </button>
    </div>

    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      *ngIf="dataTableNatural.length > 0"
      id="tblDemandanteNatural"
      [acciones]="actions"
      (eventoAccion)="accionesDemandado($event)"
      [datos]="dataTableNatural"
      [columnas]="columnsNatural"
      [paginacion]="false" />
    <br />
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      *ngIf="dataTableJuridic.length > 0"
      id="tblDemandanteJuridic"
      [acciones]="actions"
      (eventoAccion)="accionesDemandado($event)"
      [datos]="dataTableJuridic"
      [columnas]="columnsJuridic"
      [paginacion]="false" />
    <br />
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        aria-label="Atrás">
        {{ proconText['botones-envio']['atras'] }}
      </button>
      <button
        type="submit"
        class="btn-govco fill-btn-govco w-auto"

        (click)="pasarAReclamoDirecto($event, true)"
        aria-label="Guardar sin enviar">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>
      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="onClickSiguiente($event)"
        aria-label="Siguiente">
        {{ proconText['siguiente'] }}
      </button>
    </div>
    <!--[disabled]="demandados.length === 0"-->
  </div>
</ng-container>
